import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {

    getEnquiryRegDetailsUrl,
    GET_ENQUIRY_REG_DETAILS_ACTION,
    insertEnquiryUrl,
    INSERT_ENQUIRY_ACTION,
} from "../../utils/constants"

export const getEnquiryRegDetails_action = (registrationNo) => async (dispatch) => {
    try {
        const mapdata = {
            registrationNo: registrationNo,
        }
        console.log("mapdata", mapdata)

        const res = await axiosGet(getEnquiryRegDetailsUrl, mapdata);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_ENQUIRY_REG_DETAILS_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertEnquiry_action = (EnquiryID, MemberID, OrganizationTypeID, CompanyName, Title, FirstName, LastName, Email, Designation, CountryID, PhoneNo, MobileNo, EnterpriseTypeID, BusinessSegments, TradeServicesID, Query, EventID) => async (dispatch) => {
    try {
        const mapdata = {
            EnquiryID: EnquiryID ? EnquiryID : null,
            MemberID: MemberID ? MemberID : null,
            OrganizationTypeID: OrganizationTypeID,
            CompanyName: CompanyName,
            Title: Title,
            FirstName: FirstName,
            LastName: LastName,
            Email: Email,
            Designation: Designation,
            CountryID: CountryID,
            PhoneNo: PhoneNo,
            MobileNo: MobileNo,
            EnterpriseTypeID: EnterpriseTypeID,
            BusinessSegments: BusinessSegments,
            TradeServicesID: TradeServicesID,
            Query: Query,
            EventID: EventID ? EventID : null
        }
        // console.log("registrationFormAddUrl", registrationFormAddUrl)
        console.log("mapdata", mapdata)

        const res = await axiosPost(insertEnquiryUrl, mapdata);
        console.log("insertEnquiry_action res", res)

        dispatch({
            type: INSERT_ENQUIRY_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};